export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  publishDate: string;
  views: number;
  isHot: boolean;
  isExclusive: boolean;
  tags: string[];
}

export const categories = [
  { name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-user-unfollow-line', description: '网红圈最新翻车现场，第一时间曝光网红黑历史' },
  { name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', description: '娱乐圈劲爆内幕，明星私生活全面揭秘' },
  { name: '社会奇闻', slug: 'shehui-qiwen', icon: 'ri-fire-line', description: '社会热点奇闻异事，那些你不知道的惊人真相' },
  { name: '独家黑料', slug: 'dujia-heiliao', icon: 'ri-lock-line', description: '911独家一手黑料，别处看不到的猛料内容' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某千万粉网红私下辱骂粉丝录音曝光，人设崩塌现场实锤',
    summary: '近日一段长达8分钟的录音在网络疯传，某拥有千万粉丝的美食博主在私下聚会中大肆嘲讽粉丝群体，言辞激烈令人震惊。',
    content: `<p>近日，一段长达8分钟的录音在各大社交平台疯传，引发了广泛关注和讨论。据知情人士透露，录音中的主角是某拥有超过1200万粉丝的知名美食领域网红博主。</p>
    <p>录音内容显示，该网红在私下聚会中对粉丝群体进行了大量不当言论，包括"那些给我打赏的都是韭菜"、"随便发个视频他们就跟着转"等侮辱性话语。</p>
    <p>录音曝光后，该网红所属MCN机构第一时间发布声明，称录音"系恶意剪辑合成"，并表示已报警处理。然而多位音频鉴定专家表示，录音中的声音特征与该网红此前直播声音高度吻合。</p>
    <p>目前，该事件仍在持续发酵中。据第三方数据平台显示，该网红在事件曝光后24小时内掉粉超过87万。多个品牌方已紧急宣布暂停与该网红的合作关系。</p>
    <p><strong>事件最新进展：</strong>有匿名人士向911吃瓜网提供了更多该网红私下不当行为的证据，包括聊天记录截图和多段短视频，911吃瓜网将持续跟进报道。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20social%20media%20influencer%20studio%20with%20broken%20phone%20screen%20and%20scattered%20papers%2C%20warm%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20deep%20shadows%2C%20cinematic%20composition%2C%20rich%20dark%20tones&width=1600&height=900&seq=article-cover-01&orientation=landscape',
    publishDate: '2026-07-06',
    views: 2830000,
    isHot: true,
    isExclusive: true,
    tags: ['网红塌房', '录音曝光', '百万掉粉'],
  },
  {
    id: 'article-2',
    title: '顶流男星深夜密会神秘女子，酒店共度8小时被拍实锤',
    summary: '某当红一线男星被拍到深夜与一名神秘女子前后进入某五星级酒店，直至次日清晨才分别离开，全程被狗仔蹲守拍摄。',
    content: `<p>据资深娱乐记者爆料，某位近期热播剧男主角在上周三深夜，被拍到与一名神秘女子先后进入北京某五星级酒店。</p>
    <p>根据摄影师提供的多角度照片显示，该男星于当晚23:15左右抵达酒店地下车库，头戴黑色棒球帽和口罩进行遮掩。约半小时后，一名身着米色风衣的年轻女子进入同一酒店大堂，径直走向电梯。</p>
    <p>次日清晨7:30左右，该男星先行离开酒店，而神秘女子则在约半小时后从侧门离开，全程两人避开了同行。</p>
    <p>值得注意的是，该男星此前在公开场合一直以"单身"人设示人，其经纪团队也多次强调他"专注事业，暂无恋爱计划"。</p>
    <p><strong>最新跟进：</strong>911吃瓜网已联系该男星经纪公司求证，截至发稿前尚未收到正式回复。我们将持续关注此事的后续发展。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20silhouette%20figures%2C%20paparazzi%20style%20photography%2C%20cinematic%20noir%20atmosphere%2C%20dark%20streets%2C%20warm%20golden%20light%20from%20hotel%20lobby%2C%20suspenseful%20mood&width=1600&height=900&seq=article-cover-02&orientation=landscape',
    publishDate: '2026-07-05',
    views: 4120000,
    isHot: true,
    isExclusive: false,
    tags: ['明星八卦', '恋情曝光', '酒店密会'],
  },
  {
    id: 'article-3',
    title: '某知名带货主播涉嫌虚假宣传，粉丝集体维权要求退款',
    summary: '多名消费者联合投诉某头部带货主播所售"进口玻尿酸面膜"涉嫌虚假宣传，使用后多人出现严重过敏反应，已向市场监管部门举报。',
    content: `<p>近日，超过200名消费者在某知名带货主播的粉丝群中发起联合维权行动，指控该主播在直播中推销的一款"韩国进口玻尿酸面膜"存在虚假宣传问题。</p>
    <p>据维权群发起人李女士介绍，该主播在直播间中宣称面膜"含99%高纯度玻尿酸"、"使用三天即可看到明显效果"，并展示所谓的"权威检测报告"。然而多位消费者使用后出现了不同程度的过敏反应，包括面部红肿、瘙痒、起疹等症状。</p>
    <p>更令人质疑的是，有消费者将产品送往第三方检测机构检测后发现，该面膜的实际玻尿酸含量远低于宣传值，且含有未在成分表中标注的防腐剂成分。</p>
    <p>目前，已有维权消费者联名向杭州市市场监督管理局提交了投诉材料。该主播的直播间在事件曝光后已暂停直播，但其团队尚未对消费者的退款要求做出正面回应。</p>
    <p><strong>事件追踪：</strong>911吃瓜网独家获取了部分消费者的检测报告和维权聊天记录，将持续关注此事件的调查进展。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Beauty%20product%20livestream%20setup%20with%20skincare%20products%20scattered%20on%20table%2C%20dramatic%20lighting%2C%20professional%20studio%20setting%2C%20tense%20atmosphere%2C%20editorial%20photography%2C%20warm%20and%20dark%20contrasting%20tones&width=1600&height=900&seq=article-cover-03&orientation=landscape',
    publishDate: '2026-07-05',
    views: 1670000,
    isHot: true,
    isExclusive: true,
    tags: ['虚假宣传', '消费者维权', '直播带货'],
  },
  {
    id: 'article-4',
    title: '惊天大瓜！某选秀节目暗箱操作内幕曝光，排名全系内定',
    summary: '一位自称曾参与某大型选秀节目制作的前工作人员爆料，节目中所有选手排名均在录制前由节目组内定，引发全网哗然。',
    content: `<p>一位自称"前节目组工作人员"的匿名人士在社交平台发布长文，揭露某热门选秀节目背后惊人的暗箱操作内幕。据其描述，节目中的选手排名和淘汰结果并非由观众投票决定，而是由节目组高层和赞助商在每期录制前就已经敲定。</p>
    <p>该爆料者详细描述了内定流程：节目组会先根据选手的"商业价值"和"背景资源"进行评估，然后与主要赞助商开会讨论最终人选。所谓的"实时投票"数据则通过技术手段进行操控，以匹配既定的排名结果。</p>
    <p>更令人震惊的是，爆料者还提供了多张内部会议记录和聊天截图作为佐证，这些材料显示节目组高层曾明确表示"投票只是形式，谁走谁留我们说了算"。</p>
    <p>该节目组暂未对此事做出回应。但已有大量愤怒的粉丝在社交媒体发起"抵制暗箱操作"话题，话题阅读量在短短3小时内突破5000万。</p>
    <p><strong>后续进展：</strong>911吃瓜网注意到，相关监管部门已关注此事，或将介入调查。</p>`,
    category: '独家黑料',
    categorySlug: 'dujia-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20TV%20studio%20with%20dramatic%20spotlights%2C%20shadowy%20figures%20in%20meeting%20room%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20photography%2C%20deep%20contrast%20tones&width=1600&height=900&seq=article-cover-04&orientation=landscape',
    publishDate: '2026-07-04',
    views: 5980000,
    isHot: true,
    isExclusive: true,
    tags: ['选秀内幕', '暗箱操作', '排名造假'],
  },
  {
    id: 'article-5',
    title: '某城市深夜出现不明飞行物，数百市民目击拍照引热议',
    summary: '昨晚11点左右，某二线城市上空出现多个发光不明飞行物，呈编队飞行姿态持续约15分钟，数百位市民用手机记录下这一奇异现象。',
    content: `<p>昨晚（7月3日）深夜23时许，位于华中地区的某二线城市上空出现了一组不明飞行物，引发全城市民围观和拍摄。据多位目击者描述，这些不明飞行物共有5个，呈V字形编队在空中缓慢移动，发出柔和的橙黄色光芒。</p>
    <p>市民张先生告诉记者："我当时正在阳台上乘凉，突然看到天空中出现了几个光点，一开始以为是无人机表演，但它们的飞行高度和速度明显不是普通无人机能达到的。"</p>
    <p>另一位目击者王女士补充道："最奇怪的是它们完全没有声音，就那么悄无声息地在夜空中滑过，大概持续了15分钟左右就突然消失了。"</p>
    <p>目前，社交媒体上关于此次不明飞行物事件的相关视频和照片已超过数千条，话题热度持续攀升。当地气象部门和民航管理局尚未对此现象作出官方说明。</p>
    <p>有天文爱好者分析认为这可能是一次罕见的"星链"卫星过境现象，但这一说法尚未得到官方证实。</p>`,
    category: '社会奇闻',
    categorySlug: 'shehui-qiwen',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20glowing%20orbs%20in%20night%20sky%20above%20city%20skyline%2C%20UFO%20sighting%20atmosphere%2C%20dramatic%20dark%20sky%20with%20orange%20lights%2C%20cinematic%20photography%2C%20mysterious%20mood%2C%20urban%20night%20scene&width=1600&height=900&seq=article-cover-05&orientation=landscape',
    publishDate: '2026-07-04',
    views: 3450000,
    isHot: true,
    isExclusive: false,
    tags: ['不明飞行物', 'UFO', '社会奇闻'],
  },
  {
    id: 'article-6',
    title: '知名电竞选手被曝私下参与假赛，联赛官方已展开调查',
    summary: '某知名电竞战队核心选手被前队友爆料多次参与假赛牟利，涉及金额巨大。联赛官方回应称已成立专项调查组。',
    content: `<p>电竞圈再爆重磅丑闻！一位已退役的前职业电竞选手在直播中爆料，某支顶级战队的现役核心选手在过去两年中多次参与假赛，通过故意输掉比赛来获取非法博彩收益。</p>
    <p>据该退役选手透露，涉及的假赛次数至少有5场，其中包括两次重要的联赛决赛。该选手通过中间人与境外博彩平台联系，每次假赛可获得50万至200万不等的好处费。</p>
    <p>爆料者还指出，"他（涉事选手）的技术水平完全可以在关键时刻逆转局势，但那几场比赛他的操作明显异常，很多低级失误根本不像是一个顶级选手会犯的。"</p>
    <p>该消息一出，立即在电竞圈引发轩然大波。多个电竞社区和论坛的讨论帖在短时间内突破万条回复，粉丝纷纷表示震惊和愤怒。</p>
    <p>联赛官方随后在社交媒体发布声明，表示"已经注意到相关举报信息，并已成立专项调查组展开调查，将对任何违规行为零容忍"。涉事战队方面暂未作出回应。</p>`,
    category: '独家黑料',
    categorySlug: 'dujia-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20dramatic%20stage%20lighting%2C%20empty%20gaming%20chairs%2C%20dark%20atmosphere%2C%20competitive%20gaming%20setup%2C%20cinematic%20photography%2C%20tense%20mood%2C%20professional%20esports%20venue&width=1600&height=900&seq=article-cover-06&orientation=landscape',
    publishDate: '2026-07-03',
    views: 2210000,
    isHot: false,
    isExclusive: true,
    tags: ['电竞', '假赛', '职业联赛'],
  },
  {
    id: 'article-7',
    title: '娱乐圈又一模范夫妻被曝已秘密离婚，分居协议细节流出',
    summary: '圈内人士向911吃瓜网爆料，某对被誉为"娱乐圈模范夫妻"的明星夫妇已于年初秘密签署离婚协议，目前处于分居状态。',
    content: `<p>据一位与这对明星夫妇关系密切的圈内人士向911吃瓜网爆料，被粉丝誉为"娱乐圈最甜夫妇"的两位明星已经在今年年初秘密签署了离婚协议，目前双方已进入分居状态。</p>
    <p>知情人士透露，两人婚姻出现裂痕的主要原因之一是长期的聚少离多。"他们最近两年各自都在拼命接戏、上综艺，一年到头真正在一起的时间不超过一个月。"</p>
    <p>更令人唏嘘的是，两人在签署离婚协议后，仍保持着社交平台上的"恩爱互动"，继续以夫妻档身份接商业代言。爆料人称这是经纪公司为了维护商业合同而要求的"表面工作"。</p>
    <p>有细心的粉丝发现，近半年来两人各自社交账号的IP地址确实从未出现过重合，且最近三次公开活动两人都是分别到场。</p>
    <p>截至发稿前，双方工作室均未对此事作出回应。911吃瓜网将持续关注此事的官方声明。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20silhouette%20separating%20on%20empty%20theater%20stage%2C%20dramatic%20split%20lighting%2C%20emotional%20distance%2C%20cinematic%20photography%2C%20warm%20and%20cold%20color%20contrast%2C%20melancholic%20mood&width=1600&height=900&seq=article-cover-07&orientation=landscape',
    publishDate: '2026-07-03',
    views: 3710000,
    isHot: true,
    isExclusive: true,
    tags: ['明星离婚', '模范夫妻', '分居'],
  },
  {
    id: 'article-8',
    title: '某城市"幽灵公交"深夜自动行驶，监控拍下惊悚画面',
    summary: '某市一辆公交车在深夜无人驾驶的情况下自动行驶了约3公里，沿途多个监控摄像头拍下全过程，引发市民恐慌和热议。',
    content: `<p>7月2日凌晨2点左右，某中部城市发生了一起令人匪夷所思的事件：一辆公交车在没有任何驾驶员操作的情况下，自动从公交总站驶出，在城市道路上行驶了约3公里后才停下。</p>
    <p>据公交公司内部监控显示，该公交车在凌晨1:45左右突然自行启动，在没有开灯的情况下缓慢驶出了停车场。沿途多个路口监控都拍到了这辆"幽灵公交"的身影。</p>
    <p>最终，这辆公交车在行驶至一处十字路口时自动熄火停下。整个过程中没有造成任何交通事故或人员伤亡，侥幸的是当时夜深人静，路上几乎没有其他车辆和行人。</p>
    <p>公交公司技术人员初步排查后表示，事故原因可能是车辆的自动启停系统出现严重故障，加上司机下班时忘记拉手刹所致。但这一解释并未能消除市民的疑虑和恐慌。</p>
    <p>有网络安全专家提出了一个更令人担忧的可能性：公交车的车载系统可能遭到了黑客入侵，这是一次"远程劫持"事件。相关部门已介入调查。</p>`,
    category: '社会奇闻',
    categorySlug: 'shehui-qiwen',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20bus%20driving%20alone%20on%20dark%20city%20street%20at%20night%2C%20eerie%20atmosphere%2C%20streetlights%20casting%20long%20shadows%2C%20horror%20movie%20style%2C%20cinematic%20photography%2C%20mysterious%20urban%20scene&width=1600&height=900&seq=article-cover-08&orientation=landscape',
    publishDate: '2026-07-02',
    views: 1520000,
    isHot: false,
    isExclusive: false,
    tags: ['幽灵公交', '自动驾驶', '社会奇闻'],
  },
  {
    id: 'article-9',
    title: '知名综艺节目录制现场发生冲突，两位嘉宾当场互殴',
    summary: '某热门综艺节目最新一期录制过程中，两位嘉宾因观点分歧爆发激烈争吵，进而演变为肢体冲突，导致录制被迫中断。',
    content: `<p>据现场一名不愿透露姓名的工作人员向911吃瓜网爆料，某卫视一档热门综艺节目在昨日（7月1日）的最新一期录制过程中发生严重意外，两位常驻嘉宾因讨论话题产生严重分歧，从激烈争吵升级为肢体冲突。</p>
    <p>据介绍，当时节目正在录制一个辩论环节，话题涉及家庭教育方式。两位嘉宾因为观点完全相反，起初还算克制的辩论逐渐变得火药味十足，最终其中一位嘉宾拍桌而起，另一位也不甘示弱地站起推搡，场面瞬间失控。</p>
    <p>现场工作人员花了约5分钟才将两人分开，节目录制随即被迫中断。据悉，两位嘉宾都有轻微擦伤，但均未选择就医。</p>
    <p>节目组在事发后紧急召开会议，目前尚未决定是否保留这一段内容，以及是否对两位嘉宾做出处理。有消息称，该期节目可能需要进行大规模补录，播出时间或将推迟。</p>
    <p><strong>最新消息：</strong>其中一位涉事嘉宾的经纪人已私下向911吃瓜网表示，当事人对此事"深感遗憾"，并愿意向观众致歉。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20overturned%20chairs%20and%20dramatic%20lighting%2C%20tense%20confrontation%20atmosphere%2C%20talk%20show%20stage%2C%20cinematic%20photography%2C%20chaotic%20scene%2C%20professional%20studio%20lighting&width=1600&height=900&seq=article-cover-09&orientation=landscape',
    publishDate: '2026-07-02',
    views: 4890000,
    isHot: true,
    isExclusive: true,
    tags: ['综艺冲突', '嘉宾互殴', '录制中断'],
  },
  {
    id: 'article-10',
    title: '某知名网红被扒出学历造假，实际仅有初中学历',
    summary: '一位自称"海归硕士"的高知网红近日被网友扒出真实学历仅为初中毕业，其精心营造的"学霸人设"瞬间崩塌。',
    content: `<p>近日，一位以"海归硕士"、"高知女性"人设走红的美妆博主被网友扒出真实学历仅为初中毕业，其精心构建的学霸形象在一夜之间土崩瓦解。</p>
    <p>据悉，该网红在多个视频中多次声称自己毕业于英国某知名大学，获得市场营销硕士学位。她还经常在视频中分享所谓的"留学经历"和"海外生活感悟"，凭借这层"海归光环"积累了大量粉丝。</p>
    <p>然而，一位自称是该网红初中同学的网友在社交平台贴出了毕业照和学籍档案截图，证明该网红实际最高学历为当地一所乡镇中学的初中毕业证。随后，更多"老同学"和"老乡"站出来证实了这一信息。</p>
    <p>更讽刺的是，有网友查询了该网红声称毕业的英国大学校友录，并未找到其任何入学或毕业记录。</p>
    <p>事件曝光后，该网红已将所有社交媒体账号设为私密状态，并关闭了评论功能。其所属MCN机构表示"正在核实相关情况"。有业内人士分析，学历造假风波可能引发该网红多个代言合同的解约。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Fake%20diploma%20and%20certificate%20papers%20scattered%20on%20dark%20desk%2C%20dramatic%20lighting%20from%20single%20source%2C%20mysterious%20investigative%20atmosphere%2C%20editorial%20photography%2C%20dark%20academic%20aesthetic&width=1600&height=900&seq=article-cover-10&orientation=landscape',
    publishDate: '2026-07-01',
    views: 3120000,
    isHot: true,
    isExclusive: false,
    tags: ['学历造假', '人设崩塌', '网红翻车'],
  },
  {
    id: 'article-11',
    title: '某女子深夜独自在家竟拍到"鬼影"，监控视频让人毛骨悚然',
    summary: '一位独居女士家中监控摄像头深夜拍摄到一个模糊的人形影子在家中来回走动，而当时她正在卧室熟睡，房门紧锁。',
    content: `<p>家住某南方城市的张女士（化名）近日向911吃瓜网讲述了一件令她至今心有余悸的诡异经历。她家中的监控摄像头在深夜拍摄到了一个模糊的人形影子在客厅中来回走动。</p>
    <p>据张女士描述，事发当晚她大约在晚上11点就回卧室睡觉了。第二天早上查看前一晚的监控录像时，她惊恐地发现在凌晨2:30至3:15之间，客厅中出现了一个模糊的人形轮廓，缓慢地在客厅中来回移动。</p>
    <p>"我当时整个人都吓傻了，"张女士回忆道，"那个影子看起来不像是一个人，因为它的移动方式不太自然，像是飘过去的。但我检查了门窗，全部都是锁好的，没有任何被破坏的痕迹。"</p>
    <p>张女士第一时间报了警。警方到场勘查后排除了入室盗窃的可能，但也无法解释监控中的影像。有技术人员表示可能是监控设备故障或光影折射造成的假象。</p>
    <p>然而张女士坚信自己拍到了"超自然现象"，她已将视频交给第三方机构进行分析鉴定。目前鉴定结果尚未出炉，此事件已在当地引发广泛讨论。</p>`,
    category: '社会奇闻',
    categorySlug: 'shehui-qiwen',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20living%20room%20at%20night%20with%20eerie%20green%20security%20camera%20light%2C%20ghostly%20blur%20figure%2C%20horror%20movie%20atmosphere%2C%20cinematic%20photography%2C%20dark%20shadows%2C%20mysterious%20urban%20legend%20mood&width=1600&height=900&seq=article-cover-11&orientation=landscape',
    publishDate: '2026-07-01',
    views: 1860000,
    isHot: false,
    isExclusive: true,
    tags: ['灵异事件', '监控', '超自然'],
  },
  {
    id: 'article-12',
    title: '深度揭秘：某知名MCN机构的"吸血合同"，旗下网红苦不堪言',
    summary: '911吃瓜网独家调查发现，某头部MCN机构与旗下签约网红签订的合同中存在大量不平等条款，多位网红爆料被压榨经历。',
    content: `<p>在光鲜亮丽的网红经济背后，隐藏着怎样的黑暗真相？911吃瓜网耗时两周，采访了多位签约某知名MCN机构的网红博主，独家揭露了令人震惊的"吸血合同"内幕。</p>
    <p>据一位拥有80万粉丝的签约博主透露，她与MCN机构签订的是"三七分成"合同——机构拿七成，她只能拿到三成。但更夸张的是，合同规定所有内容制作成本（包括摄影、剪辑、服装等）都由她自行承担，而机构仅负责提供商务对接。</p>
    <p>还有博主爆出合同中的"霸王条款"：签约期为5年，解约需赔偿违约金高达年收入的10倍；所有社交账号归机构所有，离开时不能带走任何一个；甚至规定签约期间产生的所有创意和内容版权永久归属机构。</p>
    <p>"这根本不是合作，这是卖身契，"一位已经成功解约的匿名博主愤怒地表示。据他透露，为了跳出合同，他花了整整两年时间和近百万的律师费。</p>
    <p><strong>独家内幕：</strong>911吃瓜网还获得了一份内部的"KPI考核表"，显示该机构对旗下博主的业绩压力极其严苛，连续三个月不达标就会被克扣分成比例。</p>`,
    category: '独家黑料',
    categorySlug: 'dujia-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20contract%20papers%20and%20chains%20metaphor%2C%20dramatic%20lighting%2C%20oppressive%20atmosphere%2C%20editorial%20photography%2C%20dark%20business%20aesthetic%2C%20investigative%20journalism%20style&width=1600&height=900&seq=article-cover-12&orientation=landscape',
    publishDate: '2026-06-30',
    views: 2640000,
    isHot: false,
    isExclusive: true,
    tags: ['MCN', '霸王合同', '网红压榨'],
  },
];